import { render, staticRenderFns } from "./JeepayCard.vue?vue&type=template&id=47ed671f&scoped=true"
import script from "./JeepayCard.vue?vue&type=script&lang=js"
export * from "./JeepayCard.vue?vue&type=script&lang=js"
import style0 from "./JeepayCard.vue?vue&type=style&index=0&id=47ed671f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed671f",
  null
  
)

export default component.exports